import { Heart, ShieldCheck, FileText, Scale } from "lucide-react";
import { Link } from "react-router-dom";
import { COMMITMENT, NO_GUARANTEE, LEGAL_SELLER, TECH_ENTITY, FOUNDATION } from "@/lib/brand";

const PHOTO = "https://images.unsplash.com/flagged/photo-1559733404-9b79677fc959?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";

const ITEMS = [
    { I: FileText, t: "Written scope first", d: "Scope, fee, and timeline in writing — you sign before any payment. Government fees passed through at cost." },
    { I: Scale, t: "No guarantees", d: NO_GUARANTEE },
    { I: ShieldCheck, t: "Not a law firm or lender", d: "Document preparation and filing assistance at your direction; licensed attorneys, CPAs, and patent practitioners engaged where required." },
];

export function TrustStrip() {
    return (
        <section id="trust" className="scroll-mt-20 border-y border-slate-200 bg-slate-50 px-5 py-20 lg:px-8 lg:py-24" data-testid="trust-section">
            <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-center">
                <div className="reveal relative overflow-hidden rounded-[28px]">
                    <img src={PHOTO} alt="" loading="lazy" className="aspect-[4/3] w-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy/85 via-navy/20 to-transparent" aria-hidden="true" />
                    <div className="absolute bottom-0 left-0 right-0 p-7 text-white">
                        <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-teal-light"><Heart className="h-3.5 w-3.5" /> Community commitment</div>
                        <p className="mt-3 font-display text-lg font-semibold leading-snug sm:text-xl">{COMMITMENT}</p>
                    </div>
                </div>
                <div>
                    <div className="reveal si-eyebrow">Trust & compliance</div>
                    <h2 className="reveal mt-4 font-display text-4xl font-semibold tracking-[-0.035em] text-navy sm:text-5xl" style={{ "--d": "60ms" }}>Clear terms. <span className="font-serif-accent text-ocean">No surprises.</span></h2>
                    <ul className="mt-8 space-y-4">
                        {ITEMS.map(({ I, t, d }, i) => (
                            <li key={t} className="reveal flex gap-4 rounded-2xl border border-slate-200 bg-white p-5" style={{ "--d": `${120 + i * 80}ms` }}>
                                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal/10"><I className="h-5 w-5 text-teal" /></div>
                                <div><div className="font-display text-[15px] font-semibold text-navy">{t}</div><p className="mt-1 text-[13.5px] leading-relaxed text-slate-600">{d}</p></div>
                            </li>
                        ))}
                    </ul>
                    <div className="reveal mt-6 flex flex-wrap gap-x-5 gap-y-1 text-xs text-slate-500" style={{ "--d": "400ms" }}>
                        <span>Operator: <b className="font-semibold text-slate-700">{LEGAL_SELLER}</b></span>
                        <span>Technology: <b className="font-semibold text-slate-700">{TECH_ENTITY}</b></span>
                        <span>Nonprofit: <b className="font-semibold text-slate-700">{FOUNDATION}</b></span>
                        <Link to="/legal/terms" className="font-semibold text-ocean hover:underline" data-testid="trust-legal-link">Legal & policies →</Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
